<script setup>
/* eslint semi: 1 */

// Package imports
import { inject, ref } from 'vue';

// Component imports
import ForgotPasswordEmail from '@/components/common/sign-in/forgot-password-email.vue';
import ForgotPasswordResetPassword from '@/components/common/sign-in/forgot-password-reset-password.vue';
import AuthSuccess from '@/components/common/sign-in/auth-success-tmpl.vue';

// Constants
const PAGE_CONTENT = {
  FORGOT_PASSWORD_EMAIL: 'email',
  FORGOT_PASSWORD_RESET_PASSWORD: 'reset-password',
  FORGOT_PASSWORD_SUCCESS: 'success'
};

// Injects
const $utils = inject('$utils');

// Props
defineProps({
  isPageMini: {
    type: Boolean,
    default: false,
  }
});

const emit = defineEmits(['redirectToSignIn']);

// Variables
const pageContent = ref(PAGE_CONTENT.FORGOT_PASSWORD_EMAIL);
const email = ref(null);

// Methods

function emailSubmit (value) {
  email.value = value;
  pageContent.value = PAGE_CONTENT.FORGOT_PASSWORD_RESET_PASSWORD;
}

function passwordSubmit () {
  pageContent.value = PAGE_CONTENT.FORGOT_PASSWORD_SUCCESS;
}

function redirectToLogin () {
  // Re-route to login
  emit('redirectToSignIn', email.value);
  email.value = null;
}

function setPrefillEmail (emailValue) {
  email.value = emailValue;
}

defineExpose({
  setPrefillEmail
});
</script>

<template>
  <div
    class="sign-in-card gradient-card default py-6! px-6! flex flex-col items-center max-[1919px]:w-[276px]! max-[1919px]:min-h-[478px]! min-[1920px]:w-[356px]! min-[1920px]:min-h-[629px]!"
    :class="{ 'no-background': $utils.isPageForLicenses() }"
  >
    <!-- Title -->
    <h4
      class="forgot-password-title font-semibold uppercase text-white text-[28px] leading-[100%] py-3 text-center break-words w-full"
      data-component-element-id="forgot-password-title"
    >
      {{ pageContent === PAGE_CONTENT.FORGOT_PASSWORD_SUCCESS ? $t('label.confirmation') : $t('label.resetPassword') }}
    </h4>

    <!-- Form -->
    <forgot-password-email
      v-if="pageContent === PAGE_CONTENT.FORGOT_PASSWORD_EMAIL"
      :is-page-mini="isPageMini"
      :prefill-email="email"
      @success-submit="emailSubmit"
    />

    <forgot-password-reset-password
      v-if="pageContent === PAGE_CONTENT.FORGOT_PASSWORD_RESET_PASSWORD"
      :is-page-mini="isPageMini"
      :email="email"
      @success-submit="passwordSubmit"
    />

    <auth-success
      v-if="pageContent === PAGE_CONTENT.FORGOT_PASSWORD_SUCCESS"
      :is-page-mini="isPageMini"
      :description="$t('label.passwordHasBeenChanged')"
      :buttonText="$t('label.goToLogin')"
      @button-click="redirectToLogin"
    />
  </div>
</template>

<style lang="scss" scoped>
@media (max-width: 1919px) {
  :lang(ja) {
    .forgot-password-title {
      font-size: 16px !important;
    }
  }

  :lang(de),
  :lang(nl),
  :lang(ru) {
    .forgot-password-title {
      font-size: 22px !important;
    }
  }
}

@media (min-width: 1920px) {
  :lang(ja) {
    .forgot-password-title {
      font-size: 22px !important;
    }
  }

  :lang(de),
  :lang(nl),
  :lang(ru) {
    .forgot-password-title {
      font-size: 28px !important;
    }
  }
}
</style>
